import { useMobile } from './hooks';

export default function sendEvent(...parameters) {
  const [category, action, name] = parameters;

  if (!category || !action) return;
  if (typeof action === 'string' && action.toLowerCase().includes('unknown'))
    return;

  window?.applyAttribution?.();

  if (window?._paq) {
    window._paq.push(['trackEvent', category, action, name]);
  }
}

export function usePlatform() {
  const [isMobile] = useMobile();

  return isMobile ? 'mobile' : 'desktop';
}

export function trackAction(platform, page, action) {
  sendEvent(`${page}-${platform}`, `${page}-${platform}-${action}`, page);
}

export function sendDelayedEvent(...parameters) {
  setTimeout(() => {
    sendEvent(...parameters);
  }, 5000);
}

export function planFromPkgName(name) {
  if (!name) return null;
  const n = name.toLowerCase();
  if (n.includes('plus')) return 'Plus';
  if (n.includes('pro')) return 'Pro';
  if (n.includes('basis')) return 'Basis';
  if (n.includes('baby')) return 'Babypakket';
  return null;
}
